export default function () {
  return {
    loading: false,
    allOrganization: {
      resources: [],
      totalResources: 0,
    },
    proxyOrganizations: [],
    organizationDetailInfo: {},
    orgCourses: {
      resources: [],
      totalResources: 0,
    },
    violations: {
      resources: [],
      totalResources: 0,
    },

    allFeedback: {
      resources: [],
      totalResources: 0,
    },
    feedbackSummary: {},

    violationMetrics: [],
    violationsNotified: [],

    violationEvents: {
      totalResources: 0,
      resources: [],
    },

    devices: [],
    browsers: [],

    savedViolationFilters: {},
    blacklists: {
      resources: [],
      totalResources: 0,
    },

    courseUrlTypes: [],

    // messaging platform
    messageDistributionLists: {
      resources: [],
      totalResources: 0,
    },
    numberOfaffectedUsers: 0,
    pendingMessages: [],
    releasedMessages: {
      resources: [],
      totalResources: 0,
    },

    // accrediting entities
    accreditingEntities: [],
  };
}
